<script lang="ts">
	import Icon from "./Icon.svelte";
	import Link from "./Link.svelte";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import iconSpatial from "../../../core/assets/icons/spatial_tracking.svg?raw";
	import iconGroup from "../../../core/assets/icons/group.svg?raw";
	import iconAudioFile from "../../../core/assets/icons/audio_file.svg?raw";
	import imageGuitarInOffice from "../../../core/assets/images/guitar-in-office.png?webp&h=761&imagetools";
	export let forWhoHeadline = "";
	export let forWhoContent1 = "";
	export let forWhoContent2 = "";
	export let forWhoContent3 = "";
	export let tryApp = "";
	export let href = "";
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="flex flex-col gap-14 pb-16 pt-0 lg:flex-row lg:gap-28 lg:py-32">
	<div class="xl:shrink-0">
		<StaticPicture
			imgClass="lg:rounded-lg lg:max-h-[761px] object-cover"
			width={673}
			height={761}
			image={imageGuitarInOffice}
			alt="Jamujam guitar in office"
		/>
	</div>
	<div class="container mx-auto lg:mx-0">
		<h2 class="text-md mb-12 text-center lg:text-left lg:text-lg">{@html forWhoHeadline}</h2>
		<div class="flex flex-col gap-8">
			<div class="flex items-start gap-8">
				<Icon icon={iconSpatial} class="text-primary mt-2" />
				<span class="max-w-md text-base lg:max-w-xl">{@html forWhoContent1}</span>
			</div>
			<div class="flex items-start gap-8">
				<Icon icon={iconGroup} class="text-primary mt-2" />
				<span class="max-w-md text-base lg:max-w-xl">{@html forWhoContent2}</span>
			</div>
			<div class="flex items-start gap-8">
				<Icon icon={iconAudioFile} class="text-primary mt-2" />
				<span class="max-w-md text-base lg:max-w-xl">{@html forWhoContent3}</span>
			</div>
		</div>
		<Link variant="primary" asButton {href} class="mx-auto mt-16">
			{@html tryApp}
		</Link>
	</div>
</div>
